import { Injectable } from '@angular/core';
import { PhotoInfo } from 'src/app/features/service-insights/types/service-insight-types';

export const photoKey = (photo: PhotoInfo): string =>
  `${photo.workOrderId}|${photo.photoUrl}`;

@Injectable()
export class PhotoSelectionStore {
  private selected = new Map<string, PhotoInfo>();

  /** Toggle the selection state of a photo. If the photo is already selected, it will be deselected,
   *  and vice versa. Returns true if the photo is now selected, false if it was deselected. */
  toggle(photo: PhotoInfo) {
    const key = photoKey(photo);
    this.selected.has(key)
      ? this.selected.delete(key)
      : this.selected.set(key, photo);
  }

  /** Check if a photo is currently selected */
  isSelected(photo: PhotoInfo): boolean {
    const key = photoKey(photo);
    return this.selected.has(key);
  }

  /** Get all currently selected photos */
  getAll(): PhotoInfo[] {
    return Array.from(this.selected.values());
  }

  /** Clear all selected photos */
  clear(): void {
    this.selected.clear();
  }

  /** Get the count of currently selected photos */
  count(): number {
    return this.selected.size;
  }
}